<template>
  <NuxtImg
    v-if="isInViewport"
    ref="element"
    :src="imageProductIdentifier"
    :alt="alt"
    provider="snipes"
    :sizes="sizes"
    :loading="loading"
    :preload="false"
    :quality="quality"
    :height="height"
    :modifiers="{ skipIdExtraction: true }"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useElementVisibility } from '@vueuse/core'
import { NuxtImg } from '#components'

const element = ref<HTMLElement | null>(null)
const props = withDefaults(
  defineProps<{
    src: string
    alt: string
    sizes?: string
    quality?: number
    height?: string
    loading?: 'lazy' | 'eager'
  }>(),
  {
    sizes: 'xs:80vw sm:25vw md:20vw lg:20vw xl:20vw xxl:20vw 2xl:20vw',
    quality: 60,
    loading: 'lazy',
  },
)

const imageProductIdentifier = computed(() => {
  return props.src.split('/upload/').pop()
})

const isInViewport = computed(() => useElementVisibility(element))
</script>
